import {ChangeDetectionStrategy, Component, computed, effect, input, signal} from '@angular/core';
import {CareproviderUnitType} from '../../../../../../types/CareproviderUnitType';
import {RelatedPosts} from '../../typings/RelatedPosts';
import {DefaultValuesService} from '../../../../../../services/default-values.service';
import {UrlBuilderService} from '../../../../../../services/url-builder.service';
import {RoutesEnums} from '../../../../../../enums/RoutesEnums';
import {SearchStateFieldsEnum} from '../../../../../../enums/SearchEnums';
import {ContentPagesLabelsEnum} from '../../enums/content-pages-labels.enum';

@Component({
  selector: 'app-search-content-related-causes-v2',
  templateUrl: './search-content-related-causes-v2.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'block md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class SearchContentRelatedCausesV2Component {
  public relatedItems = input<CareproviderUnitType[]>();
  public relatedField = input<string>();
  public relatedPosts = signal<RelatedPosts[]>([]);
  public header = computed<string>(() => this.getHeader(this.relatedField()));

  constructor(
    private defaults: DefaultValuesService,
    private urlBuilder: UrlBuilderService,
  ) {
    effect(
      () => {
        this.prepareRelatedPosts(this.relatedItems());
      },
      {allowSignalWrites: true},
    );
  }

  private prepareRelatedPosts(relatedItems: CareproviderUnitType[]): void {
    if (relatedItems != null) {
      this.relatedPosts.set(
        relatedItems.map((relatedItem: CareproviderUnitType) => {
          return {
            name: relatedItem.name,
            description: relatedItem.description
              ? relatedItem.description
                  .replace(/(<([^>]+)>)/gi, '')
                  .trim()
                  .substring(0, 120) + '...'
              : '',
            routerLink: this.getRouterLink(relatedItem.urlPath),
          };
        }),
      );
    } else {
      this.relatedPosts.set([]);
    }
  }

  private getRouterLink(urlPath: string) {
    const state = this.defaults.getDefaultSearchState();
    state[this.relatedField()] = urlPath;
    return this.urlBuilder.CreateSearchResultsRouterLink(state, ['/', RoutesEnums.SEARCH]);
  }

  private getHeader(relatedField: string): string {
    switch (relatedField) {
      case SearchStateFieldsEnum.SYMPTOM:
        return ContentPagesLabelsEnum.RELATED_SYMPTOMS;
      case SearchStateFieldsEnum.CARE_SERVICE_TYPE:
        return ContentPagesLabelsEnum.RELATED_CARESERVICE_TYPES;
      default:
        return '';
    }
  }
}
